module.exports = __webpack_public_path__ + "img/zhongxiaoqiye.1c12ed66.png";